@if (!((isColorStep$ | async) || (isQtyStep$ | async) || (isLastStep$ | async))) {
  <div>
    <div style="display:flex; flex-wrap:wrap; justify-content:center; gap:15px; margin-top:20px; margin-bottom:20px">
      @for (item of items$ | async ; track item) {
        <app-product-card [levelItem]="item"
          (cardClick)="selectItem(item)">
        </app-product-card>
      }
    </div>
  </div>
}
